import * as THREE from "three";
import AddExtrudedLoopAnnotationCmd from "./AddExtrudedLoopAnnotationCmd";
import CommandIdEnum from "../enums/CommandIdEnums";
import ICanvasInputListener from "../logic/ICanvasInputListener";
import Document from "../model/document/Document";
import CommandStack from "../logic/CommandStack";
import Placement3d from "../model/Placement3d";
import AreaAnnotationData from "../model/sceneObjectData/AreaAnnotationData";

const MIN_PROFILE_POINTS = 3;

export default class AddAreaAnnotationCmd extends AddExtrudedLoopAnnotationCmd<AreaAnnotationData> {

    constructor(commandStack: CommandStack, canvasInputListener: ICanvasInputListener, document: Document) {
        super(CommandIdEnum.AddAreaAnnotation, commandStack, canvasInputListener, document);
        this.commandNameResourceKey = 'command.addAreaAnnotation.title';
        this.initialPrompResourceKey = 'command.addAreaAnnotation.selectFirstPoint';
        this.nextPointPromptResourceKey = 'command.addAreaAnnotation.selectNextPoint';
    }

    protected createInitialData(placement: Placement3d, depth: number): AreaAnnotationData {
        return new AreaAnnotationData(placement, [new THREE.Vector3(0, 0, 0)], depth);
    }

    protected onSubsequentPoint(data: AreaAnnotationData, alignedPoint: THREE.Vector3): 'continue' | 'showFinish' | 'autoFinish' {
        const offset = alignedPoint.clone().sub(data.placement.location);
        data.points.push(offset);
        data.applyAreaBasedFontSize();
        data.applyAreaBasedShowAreaText();

        return data.points.length >= MIN_PROFILE_POINTS ? 'showFinish' : 'continue';
    }

    protected buildPreviewData(data: AreaAnnotationData, alignedPoint: THREE.Vector3): AreaAnnotationData {
        const preview = data.clone();
        const offset = alignedPoint.clone().sub(data.placement.location);
        preview.points.push(offset);
        preview.applyAreaBasedFontSize();
        return preview;
    }

    protected getRefAxisPoints(data: AreaAnnotationData): THREE.Vector3[] {
        return data.points.map(p => data.placement.location.clone().add(p));
    }

    protected isReadyToFinish(data: AreaAnnotationData): boolean {
        return data.points.length >= MIN_PROFILE_POINTS;
    }

    protected finishButtonResourceKey(): string {
        return 'command.addAreaAnnotation.finish';
    }
}
